module.exports = __webpack_public_path__ + "images/emoji/baby_symbol.686fb6b1243d909326ba.png";